if (!customElements.get('blako-related-carousel')) {
  class BlakoRelatedCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-blako-related-track]');
      this.prevButton = this.querySelector('[data-blako-related-prev]');
      this.nextButton = this.querySelector('[data-blako-related-next]');
      this.controls = this.querySelector('[data-blako-related-controls]');

      if (!this.track) return;

      this.onScroll = this.updateControls.bind(this);
      this.onResize = this.updateControls.bind(this);
      this.onPrev = () => this.scrollByPage(-1);
      this.onNext = () => this.scrollByPage(1);

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.prevButton?.addEventListener('click', this.onPrev);
      this.nextButton?.addEventListener('click', this.onNext);
      window.addEventListener('resize', this.onResize);

      requestAnimationFrame(() => {
        this.updateControls();
        document.dispatchEvent(new CustomEvent('blako:content:loaded'));
      });
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.prevButton?.removeEventListener('click', this.onPrev);
      this.nextButton?.removeEventListener('click', this.onNext);
      window.removeEventListener('resize', this.onResize);
    }

    scrollByPage(direction) {
      if (!this.track) return;
      const amount = Math.max(this.track.clientWidth * 0.9, 160) * direction;
      this.track.scrollBy({ left: amount, behavior: 'smooth' });
    }

    updateControls() {
      if (!this.track) return;
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const hasOverflow = maxScroll > 2;

      if (this.controls) this.controls.hidden = !hasOverflow;
      if (!hasOverflow) return;

      if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 2;
      if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 2;
    }
  }

  customElements.define('blako-related-carousel', BlakoRelatedCarousel);
}
